export default "__VITE_ASSET__BBVIV_Dq__"